﻿'use strict';

var jquery = require('jquery');
global.$ = global.jQuery = jquery;      // To get the jQuery object in the global scope because Bootstrap 4 doesn't do modules properly

/**
* @ngdoc method
* @name initializeOurNewsFilter
* @description 
**/
exports.initialize = function initialize() {
    if ($(".news-filter").length) {
        console.log("newsFilter initialized");

        $(".news-filter").on("change", function () {

            var selectedNews = "";
            $(".news-filter option:selected").each(function () {
                selectedNews = $(this).attr("data-newscat");
            });
            $(".news-article").hide();
            $(".news-title").hide();
            $("." + selectedNews).fadeIn();
        })

        $('select').niceSelect();
    }
}

